export const STATUS_COLORS = {
  pending:        "#FBBF24",
  assigned:       "#3B82F6",
  accepted:       "#8B5CF6",
  arrived_pickup: "#EF4444",
  with_client:    "#10B981",
  pending_review: "#EC4899",
  completed:      "#14B8A6",
  cancelled:      "#EF4444",
};

export const STATUS_LABELS = {
  pending:        "Pendiente",
  assigned:       "Asignado",
  accepted:       "Aceptado",
  arrived_pickup: "Llamar cliente",
  with_client:    "Con cliente",
  pending_review: "Por aprobar",
  completed:      "Completado",
  cancelled:      "Cancelado",
};

export const DRIVER_STATUS_COLORS = {
  free: "#10B981",
  busy: "#F59E0B",
  offline: "#6B7280",
};
